import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "../styles/LandingPage.css";

export default function LandingPage() {
  const [productId, setProductId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [ingredients, setIngredients] = useState([]);

  const fetchIngredients = async () => {
    if (!productId) {
      setError("Bitte geben Sie eine Produkt-ID ein.");
      return;
    }

    setLoading(true);
    setError(null);
    setIngredients([]);

    try {
      const response = await fetch(
        `https://meine-fastapi-api-b6fyhsg2dcejcab9.westeurope-01.azurewebsites.net/product/${productId}/ingredients`
      );
      const data = await response.json();

      if (response.ok && data.length > 0) {
        setIngredients(data);
      } else {
        setError("Keine Zutaten für diese Produkt-ID gefunden.");
      }
    } catch (err) {
      setError("Fehler beim Abrufen der Daten. Bitte später erneut versuchen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="landing-container">
      {/* Hero Section */}
      <header className="hero-section">
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="hero-title">Maximieren Sie Ihr Potenzial mit erstklassigen Produktdaten</h1>
          <p className="hero-subtitle">Nutzen Sie unsere Plattform für hochwertige Daten, um Ihren Online-Shop zu optimieren.</p>
          <Link to="/kontakt" className="cta-button">Jetzt starten</Link>
        </motion.div>
      </header>

      {/* Benefits Section */}
      <section className="benefits-section">
        <h2 className="section-title">Warum unsere Lösung?</h2>
        <div className="benefits-grid">
          {[
            { title: "Kein Aufwand für Produktdaten", image: "/Geringer_Aufwand.png", desc: "Professionelle Daten – ohne eigene Recherche." },
            { title: "Zeit & Kosten sparen", image: "/Kosten_Effizienz.png", desc: "Optimierte Produktdatenbank für maximalen Erfolg." },
            { title: "Beste Datenqualität", image: "/GutenDatenQuali.png", desc: "Hochauflösende Bilder & detaillierte Beschreibungen." },
          ].map((item, index) => (
            <motion.div 
              key={index} 
              className="benefit-card"
              whileHover={{ scale: 1.05 }}
            >
              <img src={item.image} alt={item.title} className="benefit-icon" />
              <h3 className="benefit-title">{item.title}</h3>
              <p className="benefit-desc">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <h2 className="cta-title">Erleben Sie den Unterschied</h2>
        <p className="cta-subtitle">Optimieren Sie Ihr Geschäft mit unseren erstklassigen Daten.</p>
        <Link to="/kontakt" className="cta-button">Jetzt Kontakt aufnehmen</Link>
      </section>
    </div>
  );
}
